import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MenuItemService } from "@services/menuItem.service";
import { AdminMenuItem } from "@interfaces/adminMenuItem.interface";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "menu",
	styleUrls: ["menu.css"],
	templateUrl: "menu.html"
})
export class MenuAdminComponent {
	tiles: AdminMenuItem[] = [];
	tilesGrouped: any[] = [];
	title = "";

	constructor(private route: ActivatedRoute, private toastService: ToastService, private router: Router, private menuItemService: MenuItemService) {
		this.route.params
			.subscribe((params) => {

				this.getTiles(params.id);
			});
	}

	getTiles(slug: string) {
		const slugPascal = slug.replace(/(\w)(\w*)/g,
			function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); });
		this.title = slugPascal + " Menu";
		this.menuItemService.getUserMenuItems(slug)
			.subscribe(
				(res: any) => {
					this.tiles = res.response;
					this.tiles.sort((a, b) => a.text.localeCompare(b.text));
					this.tiles.sort(function (a, b) {
						if (a.category === b.category) {
							// Price is only important when cities are the same
							return a.text.localeCompare(b.text);
						}
						return a.category > b.category ? 1 : -1;
					});
					const groupTest = this.tiles.reduce(
						(result: any, currentValue: any) => {
							(result[currentValue["category"]] = result[currentValue["category"]] || []).push(currentValue);
							return result;
						}, {});
					// console.log("Test: " + test);
					// this.tilesGrouped = this.tiles.reduce(function (r, a) {
					// 	r[a.category] = r[a.category] || [];
					// 	r[a.category].push(a);
					// 	return r;
					// }, Object.create(null));

					console.log("JUST BEFORE: " + JSON.stringify(this.tilesGrouped));
					this.tilesGrouped = Object.keys(groupTest).map((e: any) => {
						console.log(groupTest[e]);
						return groupTest[e];
					});
				},
				(err) => console.log(err)
			);
	}



	navigate(route: string) {
		this.router.navigate([`admin/${route}`]);
	}
}